// extracted by mini-css-extract-plugin
module.exports = {"header":"yXfMJ","heading":"peJf5","hLeftIcon":"ur5aa","head_ellipsis":"o1wRt","small":"baeqq","linkarrow":"HjSby","medium":"Wi7uR","themewhite":"mdF2_"};